import { UserServiceClient } from 'fitbeat.api-clients';
import { profileColors } from 'fitbeat.models';
import React from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import CheckMark from '../assets/icons/checkMark.svg';
import { getApiConfig } from '../config/index';
import theme from '../theme';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { defaultScale } from '../utils/scaling';
import { updateUserProfileColor } from './actions';
import { ISwitchMemberUserProfile } from './reducer';
import { activeFamilyMemberSelector, isProfileColorChangeLoadingSelector } from './selector';
import UserDataConsumer from '../utils/UserDataConsumer';
interface IProps {
  t: (s: string) => string;
  navigation: any;
  userUpdatedProfileColor: (profileColor: string, uid: string) => void;
  activeFamilyMember: ISwitchMemberUserProfile;
  isProfileColorChangeLoading: boolean;
}

interface IState {
  profileColor: string;
}

class ChooseProfileColorComponent extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      profileColor: this.props.navigation.getParam('profileColor'),
    };
  }

  public render() {
    const { t, isProfileColorChangeLoading } = this.props;
    const { profileColor } = this.state;
    return (
      <View style={styles.container}>
        <Text style={styles.heading}>{t('chooseProfileColor')}</Text>
        <View style={styles.colorContainer}>
          {profileColors.map((color) => {
            return (
              <TouchableOpacity
                style={[styles.colorPannel, { backgroundColor: color }]}
                onPress = {() => {
                  this.changeProfileColor(color);
                }}
              >
                {color === profileColor && (
                  <>
                    {!isProfileColorChangeLoading && (
                      <CheckMark
                        width={defaultScale(35)}
                        height={defaultScale(26)}
                        fillSecondary={theme.WHITE}
                      />
                    )}
                    {isProfileColorChangeLoading && (
                      <ActivityIndicator color={theme.WHITE}/>
                    )}
                  </>
                )}
              </TouchableOpacity>
            );
          })}
        </View>
      </View>
    );
  }
  private changeProfileColor = (color: string) => {
    const {userUpdatedProfileColor, activeFamilyMember} = this.props;
    this.setState({profileColor: color});
    userUpdatedProfileColor(color, activeFamilyMember.uid);
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.WHITE,
    height: '100%',
  },
  colorContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  colorPannel: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  heading: {
    ...theme.textStyle.heading,
    marginVertical: defaultScale(30),
    marginLeft: defaultScale(16),
  },
});

const mapStateToProps = (state: any) => {
  return {
    activeFamilyMember: activeFamilyMemberSelector(state),
    isProfileColorChangeLoading: isProfileColorChangeLoadingSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  const userServiceClient = ownProps.user.userServiceClient;
  const userProfileService = ownProps.user.userProfileService;


return {
    userUpdatedProfileColor : (profileColor: string, uid: string) =>
      dispatch(updateUserProfileColor(userServiceClient, userProfileService, profileColor, uid)),
  };
};

export const ChooseProfileColor = translate(['familyPlan'])(
  UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(ChooseProfileColorComponent)),
);
